import React from 'react';
import i18n from '../../../utils/i18n';
import Button from '@adsk/bim360-matrix-react-button';

const IssueAttributesAdminCreateButton = props => (
  <Button styleType={Button.StyleType.PRIMARY} {...props}>
    {i18n.t('issueAttributesAdmin.create')}
  </Button>
);

IssueAttributesAdminCreateButton.displayName = 'IssueAttributesAdminCreateButton';

export default IssueAttributesAdminCreateButton;
